import { useState } from "react";
import "../styles/CollectionPage.css";
import Footer from "../../../components/Footer/Footer";
import { useCollections } from "../hooks/useCollections";

import CollectionSidebar from "../components/CollectionSidebar";
import CollectionGrid from "../components/CollectionGrid";
import MobileFilterModal from "../components/MobileFilterModal";
import Breadcrumbs from "../../../components/Breadcrumbs/Breadcrumbs";

const CollectionPage = () => {
  const { collections, categories, loading, error } = useCollections();

  const [isFilterOpen, setIsFilterOpen] = useState(false);

  if (error) return <p style={{ color: "red" }}>{error}</p>;

  const breadcrumbPaths = [{ label: "Collections", to: "" }];
  console.log(collections);
  return (
    <>
      <div className="breadweb">
        <Breadcrumbs paths={breadcrumbPaths} />
      </div>

      <div className="track_filter_cll">
        <Breadcrumbs paths={breadcrumbPaths} />
        <div
          className="mobile-filter-btn"
          onClick={() => setIsFilterOpen(true)}
        >
          <i className="bi bi-sliders"></i> Filters
        </div>
      </div>

      <div className="collection-container">
        <CollectionSidebar
          categories={categories}
          loading={loading}
        />

        <CollectionGrid
          collections={collections}
          loading={loading}
        />
      </div>

      <MobileFilterModal
        categories={categories}
        open={isFilterOpen}
        onClose={() => setIsFilterOpen(false)}
      />
      <Footer />
    </>
  );
};

export default CollectionPage;
